module.exports = __webpack_public_path__ + "static/media/navTemplate.e28c4c3c.svg";